import { render, staticRenderFns } from "./LoginStart.vue?vue&type=template&id=530c2fd8"
import script from "./LoginStart.vue?vue&type=script&lang=js"
export * from "./LoginStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports